import { Modal, Row, Col, Button } from 'antd';
import React from 'react';
import { getLangValue, localize } from '../helpers';
import PartWrapper from '../ui/part-wrapper';

export const checkAuthorization = (
    error,
    language: any,
    serviceName: string,
    translations: Record<string, string>
) => {
    const lang = getLangValue(language);
    if (!error || error?.response?.status === 401) {
        Modal.info({
            icon: null,
            content: (
                <PartWrapper
                    language={language}
                    isError={false}
                >
                    <Row>
                        <Col>
                            <span>{localize(`${serviceName}`, translations)}</span>
                        </Col>
                    </Row>
                    <Row
                        justify="space-between"
                        className="mt-3"
                    >
                        <Col>
                            <Button
                                color="gold"
                                type="primary"
                                onClick={() =>
                                    open(
                                        `/${lang}/pages/login?redirect=` + location.pathname,
                                        '_self'
                                    )
                                }
                            >
                                {localize('login', translations)}
                            </Button>
                        </Col>
                        <Col>
                            <Button
                                color="gold"
                                type="primary"
                                onClick={() => Modal.destroyAll()}
                            >
                                {localize('button.close', translations)}
                            </Button>
                        </Col>
                    </Row>
                </PartWrapper>
            ),
            footer: null,
        });
    }
};
